import ActionResult from 'app/src/engine/action-results/ActionResult';
import Tile, { TileLocation } from 'app/src/engine/tiles/Tile';

export default class TileActionResult extends ActionResult {
	public tile: Tile;
	public location: TileLocation;

	constructor(tile: Tile, location: TileLocation) {
		super();

		this.tile = tile;
		this.location = location;
	}
}
